/**
 * `<WakingUpGate>` — mounts the cold-start notice above the whole app.
 *
 * Deliberately wraps the router rather than living inside the signed-in shell:
 * the very first request a student makes is usually the sign-in itself, and
 * that is exactly when the server is most likely to be asleep. A notice that
 * only appeared after login would miss the one moment it is needed most.
 *
 * The hook reads the shared signal in `@mangrove/trpc-client`, which every
 * tRPC call feeds; nothing here knows about Cloud Run.
 */
import * as React from 'react';
import { useSlowRequest, useSlowRequestReason } from '@mangrove/trpc-client/react';
import { WakingUpNotice } from '@mangrove/ui';

export function WakingUpGate({ children }: { children: React.ReactNode }): React.JSX.Element {
  const slow = useSlowRequest();
  const reason = useSlowRequestReason();
  return (
    <>
      {children}
      <WakingUpNotice open={slow} reason={reason} />
    </>
  );
}
